export default __webpack_public_path__ + "static/ibm-16ff6b39b0e2929df82e0a676ebe30fd.png";